<template>
    <v-container fluid fill-height style="display: flex; align-items: flex-start;">
        <v-row justify="center" align="start" no-gutters>
            <h1 v-if="title && !!selectedRtoCategory">{{$ta(selectedRtoCategory.category_textassetid)}}</h1>
        </v-row>
        <v-row justify="center" align="center" no-gutters>
            <animated-background></animated-background>
            <div class="profile-center-wheel">
                <img src="@/assets/wheel.png"
                     id="wheel"
                     width="400"
                >
                <div class="profile-center-wheel-avatar">
                    <div class="profile-avatar-container">
                        <v-avatar size="290">
                            <v-img :src="profilePicUrl" @load="initTimelines()">
                                <template v-slot:placeholder>
                                    <div style="display: flex; align-items: center; justify-content: center; height: 100%; width: 100%;">
                                        {{$t('general.pleasewait')}}
                                    </div>
                                </template>
                            </v-img>
                        </v-avatar>
                    </div>
                </div>
                <div style="display: flex; justify-content: center;" class="pt-3">
                    <v-btn
                            color="secondary"

                            @click="$emit('back')"
                    >
                        {{actionText}}
                    </v-btn>
                </div>
            </div>
            <!--            Categories-->
            <template v-for="rtoCategory in rtoCategories">
                <v-card
                        :key="rtoCategory.journeyrtocategoryid"
                        :id="'rto_cat_' + rtoCategory.journeyrtocategoryid"
                        elevation="10"
                        color="primary"
                        min-width="200"
                        max-width="300"
                        @click="selectedRtoCategory ? closeRtoCategory() : openRtoCategory(rtoCategory)"
                        class="profile-observation-container"
                        v-if="!onlyOneCategory"
                >
                    <v-card-text>
                        <div style="display: flex; align-items: center;">
                            <div style="transition: width .4s ease-out; overflow: hidden;"
                                 :style="{width: !!selectedRtoCategory && selectedRtoCategory.journeyrtocategoryid == rtoCategory.journeyrtocategoryid ? '25px' : '0px'}">
                                <v-icon>mdi-chevron-left</v-icon>
                            </div>
                            <div>
                                {{ $ta(rtoCategory.category_textassetid) }}
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </template>
            <!--            RTOS-->
            <template v-if="!!selectedRtoCategory">
                <template v-for="rto in selectedRtoCategory.rtos">
                    <v-card
                            :key="'rto_' + rto.rtoid"
                            elevation="10"
                            color="primary"
                            width="250"
                            class="rto-container"
                            :id="'rto-container-' + rto.rtoid"
                            @mouseover="setCurrentRto(rto)"
                            @mouseleave="setCurrentRto(null)"
                    >
                        <v-card-text>
                            <v-row justify="start" align="center" no-gutters>
                                <v-col cols="12">
                                    {{ rto.title }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </template>
            </template>
        </v-row>
    </v-container>
</template>

<script>
    import {TimelineLite, Sine} from 'gsap';
    import AnimatedBackground from '../../components/display/AnimatedBackground';

    export default {
        components: {AnimatedBackground},
        props: {
            rtoCategories: {
                required: true,
                type: Object
            },
            actionText: {
                type: String,
                default: 'Back'
            },
            title: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            profilePicUrl() {
                return this.$store.getters['assessment/assessment'].profilepic.internal_url || this.$store.getters['assessment/assessment'].profilepic.url;
            },
        },
        data: () => ({
            categoriesTimeline: null,
            wheelEl: null,
            wheelTimeline: null,
            selectedRtoCategory: null,
            selectedRtoCategoryEl: null,
            // rtosTimeline: null,
            maximumRtos: null,
            // Right to left, top to bottom order = 0 1 7 8 9 6 3 5 4 2
            spreadCoordinates: [
                {
                    x: 450,
                    y: 0
                },
                {
                    x: -450,
                    y: 0
                },
                {
                    x: 400,
                    y: -150
                },
                {
                    x: -400,
                    y: -150
                },
                {
                    x: 400,
                    y: 150
                },
                {
                    x: -400,
                    y: 150
                },
                {
                    x: 300,
                    y: -250
                },
                {
                    x: -300,
                    y: -250
                },
                {
                    x: 300,
                    y: 250
                },
                {
                    x: -300,
                    y: 250
                },
            ],
            xMapped: [],
            yMapped: [],
            onlyOneCategory: false,
            visibleRtos: null,
            rtoInterval: null,
            currentRtos: [],
            benchedRtos: [],
            currentRto: null
        }),
        methods: {
            setCoordinates() {
                if(window.innerHeight <= 800) {
                    this.maximumRtos = 6;
                }
                else {
                    this.maximumRtos = 10;
                }
                //TODO: Can be replaced with static arrays to skip this step, after coordinates have been tested and increased to at least 20 positions.
                this.spreadCoordinates.forEach(coordinatePair => {
                    this.xMapped.push(coordinatePair.x);
                    this.yMapped.push(coordinatePair.y);
                });
            },
            getCycle() {
                return {
                    x: this.xMapped,
                    y: this.yMapped,
                    delay: () => {
                        return Math.floor(Math.random() * 1);
                    }
                };
            },
            initTimelines() {
                this.onlyOneCategory = Object.keys(this.rtoCategories).length == 1;
                //Wheel timeline
                this.wheelTimeline = new TimelineLite({paused: true}).to(this.wheelEl, 0.8, {
                    rotation: 100,
                    ease: Sine.easeInOut
                }).to(this.wheelEl, 0.3, {
                    rotation: 90
                });

                //Categories timeline
                this.categoriesTimeline = new TimelineLite({
                    onReverseComplete: this.renderRtos,
                }).staggerTo('.profile-observation-container', 0.6, {
                    cycle: this.getCycle(),
                    opacity: 1,
                    ease: Sine.easeInOut
                }, 0.05, '+=0', this.clearSelectedCategoryElement);

                //Rto timeline
                // this.rtosTimeline = new TimelineLite({
                //     onReverseComplete: this.removeRtos
                // });

                if (this.onlyOneCategory) {
                    this.openRtoCategory(Object.values(this.rtoCategories)[0]);
                }
            },
            openRtoCategory(rtoCategory) {
                if (rtoCategory && rtoCategory.rtos && rtoCategory.rtos.length > 0) {
                    this.selectedRtoCategoryEl = document.getElementById('rto_cat_' + rtoCategory.journeyrtocategoryid);
                    this.selectedRtoCategoryEl.classList.add('rto-selected');
                    setTimeout(() => {
                        this.selectedRtoCategory = rtoCategory;
                        this.categoriesTimeline.reverse();
                        this.wheelTimeline.restart();
                    }, 50);
                }
            },
            closeRtoCategory() {
               this.wheelTimeline.reverse();
               this.categoriesTimeline.restart();
               this.selectedRtoCategory = null;
            },
            renderRtos() {
                let rtos;
                if (this.selectedRtoCategory.rtos.length > this.maximumRtos) {
                    this.currentRtos = this.selectedRtoCategory.rtos.slice(0, this.maximumRtos);
                    this.benchedRtos = this.selectedRtoCategory.rtos.slice(this.maximumRtos);
                    rtos = this.currentRtos;
                } else {
                    rtos = this.selectedRtoCategory.rtos;
                }
                rtos.forEach((rto, rtoIndex) => {
                    this.animateRto(rto, rtoIndex);
                });
                this.selectedRtoCategory.rtos.length > this.maximumRtos && this.startSwapInterval();
            },
            animateRto(rto, rtoIndex, options = {duration: 0.6, delay: Math.random()}) {
                const {duration = 0.6, delay = Math.random()} = options;
                if (rto.timeline) {
                    rto.timeline.kill();
                }
                rto.timeline = new TimelineLite().to('#rto-container-' + rto.rtoid, duration, {
                    opacity: 1,
                    ease: Sine.easeInOut,
                    x: this.spreadCoordinates[rtoIndex].x,
                    y: this.spreadCoordinates[rtoIndex].y,
                }).delay(delay);
            },
            startSwapInterval() {
                let index = 0;
                this.rtoInterval = setInterval(() => {
                    if (!!this.currentRto && this.currentRto.rtoid == this.currentRtos[index].rtoid) {
                        index++;
                    }
                    this.currentRtos[index].timeline.reverse();
                    this.benchedRtos.push(this.currentRtos[index]);
                    this.currentRtos[index] = this.benchedRtos.splice(0, 1)[0];
                    this.animateRto(this.currentRtos[index], index, {delay: 0.5});
                    index++;
                    if (index >= this.maximumRtos) {
                        index = 0;
                    }
                }, 5000);
            },
            removeRtos() {
                this.selectedRtoCategory = null;
                this.initTimelines();
                clearInterval(this.rtoInterval);
            },
            clearSelectedCategoryElement() {
                if (this.selectedRtoCategoryEl) {
                    this.selectedRtoCategoryEl.classList.remove('rto-selected');
                    this.$nextTick(() => {
                        this.selectedRtoCategoryEl = null;
                    });
                }
            },
            setCurrentRto(rto) {
                this.currentRto = rto;
            }
        },
        mounted() {
            this.wheelEl = document.getElementById('wheel');
            this.setCoordinates();
        },
        beforeDestroy() {
            clearInterval(this.rtoInterval);
        }
    };
</script>

<style>
    .profile-center-wheel {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
    }

    .profile-center-wheel-avatar {
        width: 100%;
        height: 400px;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        position: absolute;
        z-index: 1;
    }

    .profile-avatar-container {
        border: 15px solid rgba(255, 255, 255, 0.2) !important;
        border-radius: 100%;
        z-index: 1;
    }

    .profile-observation-container {
        transition: all .4s ease-out;
        position: absolute;
        opacity: 0;
        z-index: 0;
        -webkit-filter: blur(0px);
        user-select: none;
    }

    .rto-container {
        position: absolute;
        opacity: 0;
        z-index: 0;
        -webkit-filter: blur(0px);
        user-select: none;
        transition: opacity .2s;
    }

    .rto-selected {
        opacity: 1 !important;
        z-index: 10 !important;
    }

    /*.profile-observation-floating {*/
    /*    animation-name: float;*/
    /*    animation-iteration-count: infinite;*/
    /*    animation-duration: 10s;*/
    /*    -webkit-font-smoothing: antialiased;*/
    /*}*/

    /*@keyframes float {*/
    /*    0% {*/
    /*        transform: translateX(300px) translateY(-300px);*/
    /*    }*/
    /*    50% {*/
    /*        transform: translateX(-300px) translateY(300px);*/
    /*    }*/
    /*    100% {*/
    /*        transform: translateX(300px) translateY(-300px);*/
    /*    }*/
    /*}*/
</style>